import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtobijapurcabs() {



    const cardData = {




keyword: "Belgaum to Bijapur Cab",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Bijapur cab services for family trips, business travel, pilgrimage visits, historical tours, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Bijapur, we provide safe and convenient travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options based on your travel requirements. Our services include doorstep pickup, flexible departure timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service provides hassle-free cab connectivity between Belgaum and Bijapur for tourists, families, professionals, and travelers looking for comfortable and affordable transportation across Karnataka.",

topPlaces: [
  {
    title: "Gol Gumbaz",
    description: "Gol Gumbaz is Bijapur's most famous historical monument, known for its massive dome, architectural brilliance, and rich heritage. It is a must-visit attraction for tourists traveling to Bijapur."
  },
  {
    title: "Ibrahim Rauza",
    description: "Ibrahim Rauza is a beautiful historical complex featuring elegant Islamic architecture, intricate carvings, and peaceful surroundings, attracting history and architecture lovers."
  },
  {
    title: "Bijapur Fort",
    description: "Bijapur Fort is a historic landmark surrounded by ancient structures, gateways, and monuments that showcase the city's royal past."
  },
  {
    title: "Almatti Dam",
    description: "Almatti Dam is a popular tourist attraction near Bijapur known for scenic views, gardens, boating, and peaceful surroundings, making it ideal for family outings."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's leading IT and business city, known for technology parks, corporate offices, and commercial destinations. Private cabs offer comfortable long-distance travel."
  },
  {
    title: "Pune",
    description: "Pune is a major educational, IT, and industrial hub in Maharashtra. Travelers prefer cab services for business trips, family visits, and interstate journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital and a popular destination for business, airport transfers, medical travel, and tourism. Comfortable cabs provide convenient connectivity."
  },
  {
    title: "Goa",
    description: "Goa is a famous holiday destination known for beaches, resorts, churches, and sightseeing attractions. It is a popular outstation route for leisure travelers."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for ancient temples, historical ruins, and unique landscapes, making it a preferred heritage tour destination."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a nature and adventure destination known for wildlife, forests, river rafting, and outdoor activities, attracting tourists throughout the year."
  }
],




"services": [
  {
    "name": "Belgaum to Vijayapura Cab",
    "description": "Book Belgaum to Vijayapura Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business journeys, sightseeing, and personal travel with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Bijapur Taxi",
    "description": "Choose Belgaum to Bijapur Taxi for convenient and affordable transportation between Belgaum and Bijapur. Enjoy comfortable seating, experienced drivers, clean vehicles, transparent pricing, and hassle-free booking facilities for smooth travel."
  },
  {
    "name": "Belgaum to Vijayapura Taxi",
    "description": "Book Belgaum to Vijayapura Taxi for reliable intercity travel with professional drivers and premium vehicles. Get comfortable AC taxis for personal trips, corporate travel, family journeys, and long-distance transportation."
  },
  {
    "name": "Belgaum to Bijapur Cab Service",
    "description": "Our Belgaum to Bijapur Cab Service provides dependable travel solutions with experienced chauffeurs and multiple vehicle options. Enjoy safe and comfortable journeys with Sedan, SUV, Ertiga, and Innova Crysta cabs."
  },
  {
    "name": "Belgaum to Vijayapura Cab Service",
    "description": "Choose Belgaum to Vijayapura Cab Service for affordable and reliable outstation transportation. Experience timely pickup, professional drivers, clean AC cars, and convenient booking options for every travel requirement."
  },
  {
    "name": "Belgaum to Bijapur One Way Cab",
    "description": "Hire Belgaum to Bijapur One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, doorstep pickup, comfortable vehicles, and professional chauffeur services."
  },
  {
    "name": "Belgaum to Bijapur Cab Booking",
    "description": "Complete Belgaum to Bijapur Cab Booking with easy online reservations, quick confirmation, and flexible travel options. Select the right vehicle according to your comfort, group size, and budget."
  },
  {
    "name": "Belgaum to Vijayapura Car Rental",
    "description": "Choose Belgaum to Vijayapura Car Rental for private chauffeur-driven travel with well-maintained cars. Get Sedan, SUV, Ertiga, and Innova Crysta options for comfortable and convenient journeys."
  },
  {
    "name": "Belgaum to Bijapur Outstation Cab",
    "description": "Book Belgaum to Bijapur Outstation Cab for safe long-distance travel with professional drivers and reliable vehicles. Perfect for family trips, business travel, personal visits, and customized outstation journeys."
  },
  {
    "name": "Belgaum to Bijapur Airport Cab",
    "description": "Reserve Belgaum to Bijapur Airport Cab for smooth airport transportation with punctual pickup and drop services. Travel comfortably with experienced chauffeurs and spacious AC vehicles."
  },
  {
    "name": "Belgaum to Bijapur Innova Crysta Cab",
    "description": "Book Belgaum to Bijapur Innova Crysta Cab for premium travel comfort with luxury seating, spacious interiors, and professional chauffeurs. Ideal for family tours, corporate travel, airport transfers, and group journeys."
  },
  {
    "name": "Belgaum to Bijapur Ertiga Cab",
    "description": "Choose Belgaum to Bijapur Ertiga Cab for comfortable 6 to 7 seater travel with affordable pricing. Perfect for family outings, group transportation, airport rides, and outstation trips."
  },
  {
    "name": "Belgaum to Bijapur Sedan Cab",
    "description": "Book Belgaum to Bijapur Sedan Cab for economical and comfortable travel with clean AC cars and skilled drivers. Suitable for business meetings, personal travel, and long-distance journeys."
  },
  {
    "name": "Belgaum to Bijapur Round Trip Cab",
    "description": "Hire Belgaum to Bijapur Round Trip Cab for flexible return journeys with affordable packages and experienced chauffeurs. Ideal for sightseeing, family visits, business trips, and planned travel."
  },
  {
    "name": "Belgaum to Bijapur Private Taxi",
    "description": "Choose Belgaum to Bijapur Private Taxi for exclusive chauffeur-driven transportation with privacy, comfort, and flexible schedules. Enjoy personalized travel solutions for families, professionals, and groups."
  },
  {
    "name": "Cheap Belgaum to Bijapur Cab",
    "description": "Book Cheap Belgaum to Bijapur Cab with affordable fares, quality vehicles, and reliable driver services. Enjoy budget-friendly transportation without compromising safety and comfort."
  },
  {
    "name": "Best Belgaum to Bijapur Cab Service",
    "description": "Choose the Best Belgaum to Bijapur Cab Service offering premium vehicles, experienced chauffeurs, competitive pricing, and dependable transportation solutions for all travel needs."
  },
  {
    "name": "Online Belgaum to Bijapur Cab Booking",
    "description": "Complete Online Belgaum to Bijapur Cab Booking with simple reservations, instant confirmation, transparent pricing, and multiple vehicle choices. Get convenient taxi booking services anytime."
  },
  {
    "name": "Belgaum to Bijapur Taxi Fare",
    "description": "Check Belgaum to Bijapur Taxi Fare with affordable travel packages and flexible vehicle options. Choose Sedan, Ertiga, Innova Crysta, or SUV cabs according to your journey requirements."
  },
  {
    "name": "Belgaum to Vijayapura Taxi Service",
    "description": "Book Belgaum to Vijayapura Taxi Service for reliable transportation with comfortable vehicles and professional chauffeurs. Enjoy smooth travel with one way, round trip, and outstation cab options."
  },
  {
    "name": "Belgaum to Vijayapura One Way Cab",
    "description": "Hire Belgaum to Vijayapura One Way Cab for affordable single destination travel. Get convenient pickup, comfortable seating, experienced drivers, and transparent pricing for your journey."
  },
  {
    "name": "Belgaum to Vijayapura Outstation Cab",
    "description": "Travel with Belgaum to Vijayapura Outstation Cab offering safe and comfortable long-distance transportation. Our vehicles are suitable for family trips, business travel, and personal journeys."
  },
  {
    "name": "Belgaum to Vijayapura Airport Taxi",
    "description": "Book Belgaum to Vijayapura Airport Taxi for timely airport transfer services with reliable drivers and comfortable vehicles. Enjoy hassle-free airport pickup and drop facilities."
  },
  {
    "name": "Belgaum to Vijayapura Innova Crysta Cab",
    "description": "Choose Belgaum to Vijayapura Innova Crysta Cab for luxury travel with spacious seating, premium comfort, and experienced chauffeurs. Perfect for family and corporate journeys."
  },
  {
    "name": "Belgaum to Vijayapura Ertiga Cab",
    "description": "Book Belgaum to Vijayapura Ertiga Cab for spacious and comfortable group travel. Enjoy affordable rates, clean vehicles, and professional driver assistance."
  },
  {
    "name": "Belgaum to Vijayapura Sedan Cab",
    "description": "Reserve Belgaum to Vijayapura Sedan Cab for smooth and economical travel with AC sedan cars and experienced drivers. Ideal for business and personal transportation."
  },
  {
    "name": "Belgaum to Vijayapura Car Hire",
    "description": "Hire Belgaum to Vijayapura Car Hire services for private vehicle rental with professional drivers. Choose from multiple car categories for comfortable city-to-city travel."
  },
  {
    "name": "Belgaum to Vijayapura Cab Price",
    "description": "Get affordable Belgaum to Vijayapura Cab Price with transparent fares and multiple vehicle choices. Select the best cab option based on your travel requirements and budget."
  },
  {
    "name": "Belgaum to Vijayapura Taxi Booking",
    "description": "Complete Belgaum to Vijayapura Taxi Booking with easy online reservations and quick service confirmation. Enjoy comfortable rides with trusted drivers and well-maintained vehicles."
  },
  {
    "name": "Cab Service Vijayapura",
    "description": "Book Cab Service Vijayapura for reliable local and outstation transportation with comfortable vehicles and professional drivers. Get convenient taxi solutions for airport travel, business trips, and family journeys."
  },
  {
    "name": "Cab Service Bijapur",
    "description": "Choose Cab Service Bijapur for affordable and dependable taxi solutions. Enjoy clean vehicles, experienced chauffeurs, and flexible booking options for local and outstation travel."
  },
  {
    "name": "Bijapur Taxi Service",
    "description": "Book Bijapur Taxi Service for safe and comfortable transportation with professional drivers. Get reliable cabs for city travel, airport transfers, and nearby destinations."
  },
  {
    "name": "Taxi in Bijapur",
    "description": "Hire Taxi in Bijapur for convenient travel with Sedan, SUV, Ertiga, and Innova Crysta options. Enjoy comfortable rides with experienced chauffeurs and affordable pricing."
  },
  {
    "name": "Bijapur Taxi",
    "description": "Reserve Bijapur Taxi for reliable transportation services with clean vehicles and skilled drivers. Suitable for local rides, business travel, family trips, and outstation journeys."
  }
],
"tableData": [
  ["Belgaum to Vijayapura Cab", "Belgaum to Bijapur Taxi"],
  ["Belgaum to Vijayapura Taxi", "Belgaum to Bijapur Cab Service"],
  ["Belgaum to Vijayapura Cab Service", "Belgaum to Bijapur One Way Cab"],
  ["Belgaum to Bijapur Cab Booking", "Belgaum to Vijayapura Car Rental"],
  ["Belgaum to Bijapur Outstation Cab", "Belgaum to Bijapur Airport Cab"],
  ["Belgaum to Bijapur Innova Crysta Cab", "Belgaum to Bijapur Ertiga Cab"],
  ["Belgaum to Bijapur Sedan Cab", "Belgaum to Bijapur Round Trip Cab"],
  ["Belgaum to Bijapur Private Taxi", "Cheap Belgaum to Bijapur Cab"],
  ["Best Belgaum to Bijapur Cab Service", "Online Belgaum to Bijapur Cab Booking"],
  ["Belgaum to Bijapur Taxi Fare", "Belgaum to Vijayapura Taxi Service"],
  ["Belgaum to Vijayapura One Way Cab", "Belgaum to Vijayapura Outstation Cab"],
  ["Belgaum to Vijayapura Airport Taxi", "Belgaum to Vijayapura Innova Crysta Cab"],
  ["Belgaum to Vijayapura Ertiga Cab", "Belgaum to Vijayapura Sedan Cab"],
  ["Belgaum to Vijayapura Car Hire", "Belgaum to Vijayapura Cab Price"],
  ["Belgaum to Vijayapura Taxi Booking", "Cab Service Vijayapura"],
  ["Cab Service Bijapur", "Bijapur Taxi Service"],
  ["Taxi in Bijapur", "Bijapur Taxi"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Bijapur Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides comfortable Belgaum to Bijapur cab services with professional drivers, clean vehicles, and reliable transportation for business, family, and personal travel."
  },
  {
    WhyChooseheading: "Convenient Pickup from Belgaum",
    WhyChoosedescription: "Get doorstep pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby locations with direct drop at any destination in Bijapur."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and premium vehicles based on your comfort and passenger requirements."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Service",
    WhyChoosedescription: "Book a one-way Belgaum to Bijapur cab or select a round-trip taxi package with flexible timings and convenient travel plans."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Journey",
    WhyChoosedescription: "Our skilled chauffeurs have excellent route knowledge and ensure safe driving, punctual service, and a comfortable journey from Belgaum to Bijapur."
  },
  {
    WhyChooseheading: "Affordable Belgaum to Bijapur Taxi Fare",
    WhyChoosedescription: "Enjoy competitive taxi fares with transparent pricing, customized travel packages, and no hidden charges for your outstation trip."
  },
  {
    WhyChooseheading: "Perfect for Family & Business Travel",
    WhyChoosedescription: "Our Belgaum to Bijapur cabs are ideal for family visits, business meetings, medical travel, sightseeing, and personal transportation."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Book your Belgaum to Bijapur taxi anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Bijapur Cab Service?",
    answer: "Yes, we provide reliable Belgaum to Bijapur cab services with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Bijapur?",
    answer: "Yes, one-way taxi services are available with convenient pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Bijapur travel?",
    answer: "We provide Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable vehicles."
  },
  {
    question: "Do you provide pickup from Belgaum Airport to Bijapur?",
    answer: "Yes, we provide airport taxi services from Belgaum Airport to Bijapur with timely pickup and comfortable travel."
  },
  {
    question: "Is Belgaum to Bijapur cab service available 24/7?",
    answer: "Yes, our taxi service is available 24 hours a day for your preferred travel schedule."
  },
  {
    question: "Can I book a return cab from Bijapur to Belgaum?",
    answer: "Yes, return and round-trip cab services are available with flexible travel timings."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is this cab service suitable for family and corporate travel?",
    answer: "Yes, our Belgaum to Bijapur taxi service provides comfortable travel options for families, business travelers, and groups."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Bijapur?",
    answer: "Yes, we offer private cab services with dedicated vehicles and professional drivers for a comfortable journey."
  },
  {
    question: "How can I book a Belgaum to Bijapur Cab?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Patil",
    feedback: "The Belgaum to Bijapur cab service was excellent. The driver was professional, the vehicle was clean, and the complete journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback: "We booked a taxi from Belgaum to Bijapur and had a smooth travel experience. The service was reliable, affordable, and well managed.",
    rating: 5
  }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Bijapur Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-bijapur-cab.webp",
  "description":
    "Book Belgaum to Bijapur Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Bijapur (Vijayapura) with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for outstation travel, business trips, and family journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-bijapur-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Belgaum to Bijapur Cab | Vijayapura Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Bijapur Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Bijapur (Vijayapura) with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation journeys available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Vijayapura Cab, Belgaum to Bijapur Taxi, Belgaum to Vijayapura Taxi, Belgaum to Bijapur Cab Service, Belgaum to Vijayapura Cab Service, Belgaum to Bijapur One Way Cab, Belgaum to Bijapur Cab Booking, Belgaum to Vijayapura Car Rental, Belgaum to Bijapur Outstation Taxi, Belgaum to Bijapur One Way Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtobijapurcabs;